import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

const DOC = gql`
  mutation AssignStandardUser(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $userId: ID!
    $organizationIds: [ID!]!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                assignStandardUser(
                  userId: $userId
                  organizationIds: $organizationIds
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.AssignStandardUserMutation,
  undefined,
  graphql.schema.AssignStandardUserMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
